/* eslint-disable @typescript-eslint/camelcase */

import i18next, { Resource } from 'i18next';
import moment from 'moment';
import deepmerge from 'deepmerge';
/*
    TODO: This is a horrible hack to make it possible to use this file from a Jest setup file AND and with regular Webpack builds.
    Using import moment from 'moment'; in the Jest context will cause moment to be undefined, and vice versa.
    It seems to be a problem related to using default exports. Named exports seem to work fine, as can be seen in './HistoryService.ts'.
    A better way must be found!
*/

export type ContentLanguagesDefinition = 'en_us' | 'es_co' | 'es_es' | 'fr_fr' | 'nl_nl' | 'no_no' | 'no_no_ny' | 'pl_pl'
    | 'de_de' | 'sv_se' | 'he_il' | 'iw_il' | 'cy_gb'| 'is_is' | 'fi_fi' | 'pt_pt' | 'ru_ru' | 'da_dk';

/**
 * Default marketplace content languages matching the legacy AddTestLanguageModalView.
 * Used as fallback when window.supportedContentLanguages is not injected by the host page.
 */
export const DEFAULT_CONTENT_LANGUAGES: ContentLanguagesDefinition[] = ['en_us'];

export enum LanguagesDefinition {
    EN_US = 'en-US',
    ES_CO = 'es-CO',
    ES_ES = 'es-ES',
    FR_FR = 'fr-FR',
    NB_NO = 'nb-NO',
    NL_NL = 'nl-NL',
    NN_NO = 'nn-NO',
    PL_PL = 'pl-PL',
    DE_DE = 'de-DE',
    SV_SE = 'sv-SE',
    HE_IL = 'he_IL',
    CY_GB = 'cy-GB',
    IS_IS = 'is-IS',
    FI_FI = 'fi-FI',
    PT_PT = 'pt-PT',
    RU_RU = 'ru-RU',
    DA_DK = 'da-DK',
    IW_IL = 'iw-IL',
}

export type SupportedLanguages = {
    [key in LanguagesDefinition]?: string;
}

export const marketplaceLanguageOverrides: any = {
    fjord: {
        [LanguagesDefinition.EN_US]: 'en-GB-fjord',
    },

    k12: {
        [LanguagesDefinition.EN_US]: 'en-GB-K12',
        [LanguagesDefinition.NN_NO]: 'nn-NO-K12',
        [LanguagesDefinition.NB_NO]: 'nb-NO-K12',
        [LanguagesDefinition.SV_SE]: 'sv-SE-K12',
    },
};

let i18nModule = i18next;
let momentModule = moment;
export const ALL_SUPPORTED_LANGUAGES: SupportedLanguages = {
    [LanguagesDefinition.NB_NO]: 'Norwegian - Bokmål',
    [LanguagesDefinition.EN_US]: 'English',
    [LanguagesDefinition.NN_NO]: 'Norwegian - Nynorsk',
    [LanguagesDefinition.FR_FR]: 'French',
    [LanguagesDefinition.RU_RU]: 'Russian',
    [LanguagesDefinition.DE_DE]: 'German',
    [LanguagesDefinition.SV_SE]: 'Swedish',
    [LanguagesDefinition.DA_DK]: 'Danish',
    [LanguagesDefinition.IS_IS]: 'Icelandic',
    [LanguagesDefinition.FI_FI]: 'Finnish',
    [LanguagesDefinition.ES_ES]: 'Spanish (Spain)',
    [LanguagesDefinition.PL_PL]: 'Polish',
    [LanguagesDefinition.ES_CO]: 'Spanish',
    [LanguagesDefinition.NL_NL]: 'Dutch',
    [LanguagesDefinition.HE_IL]: 'Hebrew',
    [LanguagesDefinition.CY_GB]: 'Welsh',
    [LanguagesDefinition.PT_PT]: 'Portuguese',
    [LanguagesDefinition.IW_IL]: 'Hebrew (legacy)',
};

let supportedLanguages: SupportedLanguages = { ...ALL_SUPPORTED_LANGUAGES };

if (process.env.NODE_ENV === 'test') {
    i18nModule = require('i18next');
    momentModule = require('moment');
}

const i18nService = {
    fallbackLanguage: LanguagesDefinition.EN_US,
    languageChangeEvent: 'language:changed',
    languageMapInsperaToIetf: {
        en_us: LanguagesDefinition.EN_US,
        es_co: LanguagesDefinition.ES_CO,
        es_es: LanguagesDefinition.ES_ES,
        fr_fr: LanguagesDefinition.FR_FR,
        nl_nl: LanguagesDefinition.NL_NL,
        no_no: LanguagesDefinition.NB_NO,
        no_no_ny: LanguagesDefinition.NN_NO,
        pl_pl: LanguagesDefinition.PL_PL,
        de_de: LanguagesDefinition.DE_DE,
        sv_se: LanguagesDefinition.SV_SE,
        he_il: LanguagesDefinition.HE_IL,
        iw_il: LanguagesDefinition.IW_IL,
        cy_gb: LanguagesDefinition.CY_GB,
        is_is: LanguagesDefinition.IS_IS,
        fi_fi: LanguagesDefinition.FI_FI,
        pt_pt: LanguagesDefinition.PT_PT,
        ru_ru: LanguagesDefinition.RU_RU,
        da_dk: LanguagesDefinition.DA_DK,
    },

    languageMapIetfToInsperaContent: {
        [LanguagesDefinition.EN_US]: 'en_us',
        [LanguagesDefinition.ES_CO]: 'es_co',
        [LanguagesDefinition.ES_ES]: 'es_es',
        [LanguagesDefinition.FR_FR]: 'fr_fr',
        [LanguagesDefinition.NB_NO]: 'no_no',
        [LanguagesDefinition.NL_NL]: 'nl_nl',
        [LanguagesDefinition.NN_NO]: 'no_no_ny',
        [LanguagesDefinition.PL_PL]: 'pl_pl',
        [LanguagesDefinition.DE_DE]: 'de_de',
        [LanguagesDefinition.SV_SE]: 'sv_se',
        [LanguagesDefinition.HE_IL]: 'he_il',
        [LanguagesDefinition.IW_IL]: 'iw_il',
        [LanguagesDefinition.CY_GB]: 'cy_gb',
        [LanguagesDefinition.IS_IS]: 'is_is',
        [LanguagesDefinition.FI_FI]: 'fi_fi',
        [LanguagesDefinition.PT_PT]: 'pt_pt',
        [LanguagesDefinition.RU_RU]: 'ru_ru',
        [LanguagesDefinition.DA_DK]: 'da_dk',
    },

    languageMapIdToIetf: {
        1: LanguagesDefinition.NB_NO,
        2: LanguagesDefinition.EN_US,
        3: LanguagesDefinition.NN_NO,
        4: LanguagesDefinition.FR_FR,
        5: LanguagesDefinition.RU_RU,
        6: LanguagesDefinition.DE_DE,
        7: LanguagesDefinition.SV_SE,
        8: LanguagesDefinition.DA_DK,
        9: LanguagesDefinition.IS_IS,
        10: LanguagesDefinition.FI_FI,
        11: LanguagesDefinition.ES_ES,
        12: LanguagesDefinition.PL_PL,
        13: LanguagesDefinition.ES_CO,
        14: LanguagesDefinition.NL_NL,
        15: LanguagesDefinition.HE_IL,
        17: LanguagesDefinition.CY_GB,
        18: LanguagesDefinition.PT_PT,
    },

    toInsperaLocale(locale?: string): string | undefined {
        if (!locale) {
            return locale;
        }

        const lowerLocale = locale.toLowerCase();
        const ietfToInspera = this.languageMapIetfToInsperaContent as Record<string, string>;

        // IETF input: look it up in the IETF -> Inspera map. Matched case-insensitively
        // as well, because content XML is not guaranteed to use the canonical casing.
        const fromIetfMap = ietfToInspera[locale]
            || ietfToInspera[Object.keys(ietfToInspera).find((key) => key.toLowerCase() === lowerLocale)];
        if (fromIetfMap) {
            return fromIetfMap;
        }

        // Already an Inspera code: the reverse map is keyed by exactly the valid ones.
        if ((this.languageMapInsperaToIetf as Record<string, string>)[lowerLocale]) {
            return lowerLocale;
        }

        return lowerLocale.replace(/-/g, '_');
    },

    /**
     * Converts a legacy Inspera locale (e.g. 'en_us', 'no_no') to modern IETF format (e.g. 'en-US', 'nb-NO').
     */
    toIetfLocale(locale?: string): string | undefined {
        if (!locale) {
            return locale;
        }

        const lowerLocale = locale.toLowerCase();

        // Inspera input: the Inspera -> IETF map is keyed by the lowercase Inspera codes.
        const fromInsperaMap = (this.languageMapInsperaToIetf as Record<string, string>)[lowerLocale];
        if (fromInsperaMap) {
            return fromInsperaMap;
        }

        // Already an IETF tag: return it in the canonical casing the maps use.
        const canonicalIetf = Object.keys(this.languageMapIetfToInsperaContent as Record<string, string>).find(
            (key) => key.toLowerCase() === lowerLocale
        );

        return canonicalIetf || locale;
    },

    normalizeToContentLanguage(language: string): ContentLanguagesDefinition {
        if (!language) {
            return 'en_us' as ContentLanguagesDefinition;
        }
        // Map IETF-style language tags (e.g. "en-US") to Inspera content keys (e.g. "en_us").

        const normalized = this.toInsperaLocale(language);
        return (normalized ? normalized.toLowerCase() : 'en_us') as ContentLanguagesDefinition;
    },

    getCurrentLanguageId(currentLanguage: string): string {
        return Object
            .keys(this.languageMapIdToIetf)
            .find((key) => this.languageMapIdToIetf[key] === currentLanguage);
    },
    getCurrentLanguageKey(currentLanguage: string): string {
        return Object.keys(this.languageMapInsperaToIetf)
            .find((key) => this.languageMapInsperaToIetf[key] === currentLanguage);
    },
    getCurrentLanguageById(languageId: string): LanguagesDefinition {
        return this.languageMapIdToIetf[languageId];
    },
    getSupportedLanguages(supportedUiLanguages?: string[]): SupportedLanguages {
        if (supportedUiLanguages) {
            const marketplaceSupportedLanguages: SupportedLanguages = {};
            supportedUiLanguages.forEach((key) => {
                const languageCode: LanguagesDefinition = this.languageMapInsperaToIetf[key];
                if (Object.keys(supportedLanguages).includes(languageCode)) {
                    marketplaceSupportedLanguages[languageCode] = supportedLanguages[languageCode];
                }
            });
            supportedLanguages = marketplaceSupportedLanguages;
        }

        return supportedLanguages;
    },
    /**
     * Pure version of getSupportedLanguages — filters without mutating module state.
     * Use this for content-language pickers that should not shrink the global set.
     * updated the logic to normalize the key
     */
    getFilteredLanguages(keys: string[]): SupportedLanguages {
        const result: SupportedLanguages = {};

        keys.forEach((key) => {
            const normalizedKey = key.toLowerCase();

            const languageCode: LanguagesDefinition = this.languageMapInsperaToIetf[normalizedKey];

            if (languageCode && ALL_SUPPORTED_LANGUAGES[languageCode]) {
                result[languageCode] = ALL_SUPPORTED_LANGUAGES[languageCode];
            }
        });

        return result;
    },
    /**
     * Gets the language code to use for translations.
     * It may be in the languageId param.
     * If not, a fallback language is used.
     */
    getInitialLanguage(): LanguagesDefinition {
        const languageFromLocalStorage: LanguagesDefinition = this.languageMapInsperaToIetf[localStorage.getItem('locale')];

        if (languageFromLocalStorage && supportedLanguages[languageFromLocalStorage]) {
            return languageFromLocalStorage;
        }

        if (window.languageId) {
            const languageFromServer = this.getCurrentLanguageById(window.languageId);
            const insperaLanguage = this.languageMapIetfToInsperaContent[languageFromServer];

            if (insperaLanguage) {
                localStorage.setItem('locale', insperaLanguage);

                return languageFromServer;
            }
        }

        return this.fallbackLanguage;
    },

    getFallbackLanguage(): ContentLanguagesDefinition {
        const marketplaceFirst = window.supportedContentLanguages?.[0];
        const candidate = marketplaceFirst || this.getInitialLanguage() || this.fallbackLanguage;
        return this.normalizeToContentLanguage(candidate);
    },

    returnTranslationsObject(resources: any, defaultLangCode: SupportedLanguages, overrideLangCode: string): Resource {
        if (resources[overrideLangCode]) {
            const captionsToOverrideCommon = resources[defaultLangCode as keyof SupportedLanguages].common;
            const overrideCaptionsCommon = resources[overrideLangCode]?.common;
            if (!overrideCaptionsCommon) {
                console.error(`Found no common override captions for ${overrideLangCode} using default ${defaultLangCode}`);
            }
            const captionsToOverride = resources[defaultLangCode as keyof SupportedLanguages].translation;
            const overrideCaptions = resources[overrideLangCode]?.translation;
            if (!overrideCaptions) {
                console.error(`Found no main override captions for ${overrideLangCode} using default ${defaultLangCode}`);
            }

            resources[defaultLangCode as keyof SupportedLanguages].common = deepmerge(
                captionsToOverrideCommon,
                overrideCaptionsCommon || {},
            );
            resources[defaultLangCode as keyof SupportedLanguages].translation = deepmerge(
                captionsToOverride,
                overrideCaptions || {},
            );
            delete resources[overrideLangCode];

            return resources;
        }

        return resources;
    },

    getOverrideLanguageCode(ietfLanguageCode: SupportedLanguages) {
        const { UI_LANGUAGE_OVERRIDE } = window.marketplaceProperties;

        if (UI_LANGUAGE_OVERRIDE && marketplaceLanguageOverrides[UI_LANGUAGE_OVERRIDE]) {
            return marketplaceLanguageOverrides[UI_LANGUAGE_OVERRIDE][ietfLanguageCode as keyof SupportedLanguages];
        }
        return undefined;
    },

    buildResourceBundle(resources: any, ietfLanguageCode: SupportedLanguages, uiOverrideLang: string): Resource {
        const overrideLanguageCode = this.getOverrideLanguageCode(ietfLanguageCode, uiOverrideLang);

        return this.returnTranslationsObject(resources, ietfLanguageCode, overrideLanguageCode);
    },

    initI18n(resources: any, appSupportedLanguages: SupportedLanguages, uiOverrideLang?: string): void {
        if (appSupportedLanguages) {
            supportedLanguages = appSupportedLanguages;
        }

        const initialLanguage = this.getInitialLanguage();
        const newResources = this.buildResourceBundle(resources, initialLanguage, uiOverrideLang);
        momentModule.locale(initialLanguage);
        i18nModule.init({
            resources: newResources,
            lng: initialLanguage,
            fallbackLng: this.fallbackLanguage,
            interpolation: { prefix: '__', suffix: '__' },
        });
    },

    /**
     * Changes the language used for translations.
     *
     * @param {string} language IETF language code, eg: en-US or nn-NO
     * @param {function} callback
     */
    changeLanguage(language: LanguagesDefinition, callback?: (err: object) => any): void {
        const insperaLanguage = this.languageMapIetfToInsperaContent[language];

        localStorage.setItem('locale', insperaLanguage);
        i18nModule.changeLanguage(language, callback);
    },

    translate(key: string, options: object): string {
        return i18nModule.t(key, options);
    },
};

export default i18nService;

export function hasTL(key: string) {
    return i18nModule.exists(key);
}

export function tl(key: string, options?: object, fallback?: string): string {
    if (fallback && !i18nModule.exists(key)) {
        return fallback;
    }
    return i18nService.translate(key, { ...options, ns: ['translation', 'common', 'rubrics'] });
}

/**
 * Returns a translation function bound to a specific content language.
 * Use this when generating content (e.g. question XML templates) that must
 * be in the question's target language rather than the current UI language.
 * @param insperaLanguage - language code in Inspera format (e.g. 'sv_se')
 */
export function getTlForLanguage(insperaLanguage: string) {
    const lng = i18nService.toIetfLocale(insperaLanguage) || insperaLanguage;
    return (key: string, options?: object): string => tl(key, { ...options, lng });
}

export function getIetfContentLanguage(insperaLanguage?: string): string | undefined {
    return i18nService.toIetfLocale(insperaLanguage);
}

export function getInsperaContentLanguage(ietfLanguage?: string): string | undefined {
    return i18nService.toInsperaLocale(ietfLanguage);
}


type ItemBodyLanguageAttrs = {
    doc: Document;
    itemBody: Element;
    defaultAttrName: string;
    supportedAttrName: string;
    defaultLanguage: string;
    supportedLanguages: string[];
};

function readItemBodyLanguageAttrs(textContent: string): ItemBodyLanguageAttrs | undefined {
    const parser = new DOMParser();
    const doc = parser.parseFromString(textContent, 'text/xml');
    const itemBody = doc.querySelector('itemBody')
        || doc.querySelector('[data-defaultlanguage], [data-supportedlanguages]');
    if (!itemBody) return undefined;

    const usesDataAttrs = itemBody.hasAttribute('data-defaultlanguage') // NOSONAR typescript:S7761
        || itemBody.hasAttribute('data-supportedlanguages'); // NOSONAR typescript:S7761
    const defaultAttrName = usesDataAttrs ? 'data-defaultlanguage' : 'inspera:defaultLanguage';
    const supportedAttrName = usesDataAttrs ? 'data-supportedlanguages' : 'inspera:supportedLanguages';

    const supportedAttr = itemBody.getAttribute(supportedAttrName) || '';

    return {
        doc,
        itemBody,
        defaultAttrName,
        supportedAttrName,
        defaultLanguage: itemBody.getAttribute(defaultAttrName) || '',
        supportedLanguages: supportedAttr
            ? supportedAttr.split(',').map((language) => language.trim()).filter(Boolean)
            : [],
    };
}

function hasAnyLanguageInIetfFormat(defaultLanguage: string, supportedLanguages: string[]): boolean {
    const canonicalDefault = getInsperaContentLanguage(defaultLanguage);
    const defaultIsIetf = canonicalDefault !== defaultLanguage;
    const anySuportedIsIetf = supportedLanguages.some((lang) => getInsperaContentLanguage(lang) !== lang);
    return defaultIsIetf || anySuportedIsIetf;
}

function hasFormatMismatchBetweenDefaultAndSupported(defaultLanguage: string, supportedLanguages: string[]): boolean {
    const canonicalDefault = getInsperaContentLanguage(defaultLanguage);
    return supportedLanguages.some((language) => (
        getInsperaContentLanguage(language) === canonicalDefault
        && language !== defaultLanguage
    ));
}

export function getItemBodyLanguageNormalizationStatus(textContent: string): {
    needsNormalization: boolean;
    needsHealing: boolean;
    attrs?: ItemBodyLanguageAttrs;
} {
    const none = { needsNormalization: false, needsHealing: false };
    try {
        const attrs = readItemBodyLanguageAttrs(textContent);
        if (!attrs?.defaultLanguage) return none;

        const { doc, defaultLanguage, supportedLanguages } = attrs;
        const canonicalDefault = getInsperaContentLanguage(defaultLanguage);

        const formatMismatch = hasFormatMismatchBetweenDefaultAndSupported(defaultLanguage, supportedLanguages);
        const anyIetfFormat = hasAnyLanguageInIetfFormat(defaultLanguage, supportedLanguages);

        const ietfDefault = getIetfContentLanguage(canonicalDefault);
        const langSelectors = Array.from(new Set([canonicalDefault, ietfDefault].filter(Boolean)))
            .map((code) => `[lang="${code}" i][style*="display"]`)
            .join(', ');

        const candidate = langSelectors ? doc.querySelector(langSelectors) : null;
        const needsHealing = !!candidate && /display\s*:\s*none/i.test(candidate.getAttribute('style') || '');

        return {
            needsNormalization: formatMismatch || anyIetfFormat,
            needsHealing,
            attrs,
        };
    } catch (e) {
        console.warn('Error while checking item body language format', e);
        return none;
    }
}

export function normalizeItemBodyLanguageAttrs(
    attrs: ItemBodyLanguageAttrs,
    langFormat: 'inspera' | 'ietf'
): void {
    const {
        itemBody, defaultAttrName, supportedAttrName, defaultLanguage, supportedLanguages,
    } = attrs;

    if (!defaultLanguage && supportedLanguages.length === 0) return;

    const toPersist = (code: string) => {
        if (langFormat === 'inspera') {
            return getInsperaContentLanguage(code) || code;
        }

        return getIetfContentLanguage(code) || code;
    };

    const defaultForAttr = toPersist(defaultLanguage);
    const supportedForAttr = Array.from(new Set(
        [defaultLanguage, ...supportedLanguages].filter(Boolean).map(toPersist).filter(Boolean)
    )).join(',');

    if (defaultForAttr === defaultLanguage && supportedForAttr === supportedLanguages.join(',')) {
        return;
    }

    if (defaultForAttr) itemBody.setAttribute(defaultAttrName, defaultForAttr);
    if (supportedForAttr) itemBody.setAttribute(supportedAttrName, supportedForAttr);
}


export function removeDisplayNoneFromLanguageElements(attrs: ItemBodyLanguageAttrs): void {
    const { doc, defaultLanguage } = attrs;

    const languageElements = doc.querySelectorAll('[lang][style]');

    languageElements.forEach((element) => {
        const langAttr = element.getAttribute('lang') || '';
        const style = element.getAttribute('style') || '';

        // Only heal elements with BOTH lang and style="display: none"
        const hasDisplayNone = /display\s*:\s*none/i.test(style);
        if (!hasDisplayNone) return;

        const langInInspera = getInsperaContentLanguage(langAttr);

        // Heal stale elements: convert lang="en_us" style="display: none" to style="" to make corrupted content visible
        if (langInInspera && langInInspera === getInsperaContentLanguage(defaultLanguage)) {
            element.removeAttribute('lang');

            // Remove display:none from style
            const cleaned = style.replace(/display\s*:\s*none\s*;?/gi, '').trim();
            element.setAttribute('style', cleaned || '');
        }
    });
}
